import { createContext } from "react";
import { WebPushRegistrationDto } from "./WebPushRegistrationDto";

export interface PushNotificationContextType {
  permission: NotificationPermission;
  subscription: PushSubscription | null;
  isSubscribed: boolean;
  isLoading: boolean;
  error: string | null;
  subscribeWeb: () => Promise<WebPushRegistrationDto | null>;
  unsubscribe: (subscriptionId: string) => Promise<void>;
}
export const PushNotificationContext = createContext<
  PushNotificationContextType | undefined
>(undefined);
